<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="dedication" id="_idParaDest-1"><a id="_idTextAnchor000"></a>To <em class="italic _idGenCharOverride-1">my wife</em>, who suggested the idea from which this story grew</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-3-22.vue?31f0fb50